var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import videojs from 'video.js';
import { observable, makeObservable } from 'mobx';
import { observer } from 'mobx-react';
import { css, StyleSheet } from 'aphrodite';
import { ZIndex } from '../../constants';
import { MediaBreakPointUp } from '../../styles';
import { bind } from 'bind-decorator';
const VideoSideSuper = observer(class VideoSideSuper extends React.Component {
    render() {
        return (React.createElement("div", { className: css(styles.container) }, this.props.vm.isFullScreen ? (React.createElement("div", { className: css(styles.titleContainer) },
            React.createElement("div", { className: css(styles.title) }, this.props.vm.title),
            React.createElement("div", { className: css(styles.seriesTitle) }, this.props.vm.seriesTitle))) : (React.createElement("div", { className: css(styles.iconContainer), onClick: this.props.onClickExit, "data-test": "exitButton" },
            React.createElement("img", { src: "/assets/images/video/back.svg", className: css(styles.icon) })))));
    }
});
class VjsVideoSideSuperVM {
    constructor() {
        Object.defineProperty(this, "isFullScreen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: false
        });
        Object.defineProperty(this, "title", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "seriesTitle", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this, {
            isFullScreen: observable,
            title: observable,
            seriesTitle: observable,
        });
    }
    setIsFullScreen(isFullScreen) {
        this.isFullScreen = isFullScreen;
    }
    setTitle(title) {
        this.title = title;
    }
    setSeriesTitle(seriesTitle) {
        this.seriesTitle = seriesTitle;
    }
}
__decorate([
    bind
], VjsVideoSideSuperVM.prototype, "setIsFullScreen", null);
__decorate([
    bind
], VjsVideoSideSuperVM.prototype, "setTitle", null);
__decorate([
    bind
], VjsVideoSideSuperVM.prototype, "setSeriesTitle", null);
export default class VjsVideoSideSuper extends videojs.getComponent('Component') {
    constructor(player, options) {
        super(player, options);
        Object.defineProperty(this, "videoSideSuperOptions", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "videoSideSuperPlayer", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        Object.defineProperty(this, "vm", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
        this.videoSideSuperOptions = options;
        this.videoSideSuperPlayer = player;
        this.vm = new VjsVideoSideSuperVM();
        this.mount = this.mount.bind(this);
        this.videoSideSuperPlayer.ready(() => {
            this.mount();
        });
    }
    mount() {
        const root = ReactDOM.createRoot(this.el());
        root.render(React.createElement("div", { className: "vjs-video-side-super" },
            React.createElement(VideoSideSuper, { vjsComponent: this, vm: this.vm, onClickExit: this.videoSideSuperOptions.onClickExit })));
    }
}
const styles = StyleSheet.create({
    container: {
        display: 'block',
        position: 'absolute',
        top: 0,
        left: 0,
        width: '60%',
        zIndex: ZIndex.VideoPlayButton,
    },
    titleContainer: {
        marginTop: 16,
        marginLeft: 24,
    },
    title: {
        fontWeight: 'bold',
        fontSize: 14,
        lineHeight: '140%',
        letterSpacing: '0.04em',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    seriesTitle: {
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '160%',
        letterSpacing: '0.04em',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    iconContainer: {
        cursor: 'pointer',
        display: 'inline-block',
        marginTop: 14,
        marginLeft: 16,
        textAlign: 'center',
        transition: 'opacity 0.2s',
        ':hover': {
            opacity: 0.8,
        },
        [MediaBreakPointUp.MD]: {
            marginLeft: 24,
        },
    },
    icon: {
        width: 24,
    },
});
